module.exports = __webpack_public_path__ + "img/Manu_O_.69713cef.jpg";